
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 587.29 730.03"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('g',{attrs:{"id":"Envelope"}},[_c('path',{attrs:{"fill":"#c2356b","d":"M0 293.65h587.29v436.38H0z"}}),_c('path',{attrs:{"fill":"#d2d4d4","d":"M587.29 293.65L293.65 587.29 0 293.65h587.29z"}}),_c('path',{attrs:{"id":"flap","fill":"#871a4f","d":"M587.29 293.65L293.65 0 0 293.65h587.29z"}})])])])])
          )
        }
      }
    